import type { SxProps, Theme } from "@mui/material/styles";

// Section container - visible in flow, animates upward on scroll
export const sectionContainerSx: SxProps<Theme> = {
  width: "100%",
  position: "relative",
  zIndex: 10,
  flex: "0 0 auto",
};

export const contentWrapperSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
};

export const lineAndBubbleWrapperSx: SxProps<Theme> = {
  position: "relative",
  display: "flex",
  justifyContent: "flex-end",
  width: "100%",
};

export const descriptionSx: SxProps<Theme> = {
  color: "text.secondary",
  width: { xs: "100%", sm: "55%" },
  lineHeight: 1.25,
  padding: { xs: "1rem 1rem 0rem 0rem", sm: "0 1rem 4rem 0rem" },
  marginBottom: "1px",
};
